export default __webpack_public_path__ + "static/chili-peppers-circle-eecc85f3c43321a605179cb65bf09ca9.jpg";